
import { mapActions, mapState, mapGetters } from "vuex";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
export default {
  components: { ConfirmationDialog },
  data() {
    return {
      recieverSettingsObj: {},
      loading: false,
      onlineSwitch: true,
      showStoreConfirmationDialog: false
    };
  },
  props: {
    showLabel: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters("restaurant", ["isLocationOnline"])
  },
  watch: {
    isLocationOnline(val) {
      this.onlineSwitch = val;
    }
  },
  mounted() {
    this.onlineSwitch = this.isLocationOnline;
  },
  methods: {
    ...mapActions("reciever", ["patchLocationState"]),
    handleSwitchToggle(val) {
      this.handleOfflineDialog(val);
    },
    switchChange(val) {
      this.loading = true;
      this.patchLocationState({ new_state: val ? "online" : "offline" })
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response?.data?.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("store-switch-toggled", val);
        })
        .catch((errr) => {
          this.onlineSwitch = !val;
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOfflineDialog(val) {
      if (!val) {
        this.showStoreConfirmationDialog = true;
      } else {
        this.switchChange(val);
      }
    },
    switchOfflineMobile() {
      this.switchChange(this.onlineSwitch);
      this.showStoreConfirmationDialog = false;
    },
    handleOfflineCancellation() {
      this.onlineSwitch = true;
      this.showStoreConfirmationDialog = false;
    }
  }
};
